export const layout = () => (
  <path
    d="M3 9h18M9 21V9M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
